export interface IGlobalSearchProps {
  location: any;
  isHotelPage?: boolean;
  isSearchModal?: boolean;
  onSearchSubmit?: any;
  isBrandHotelSearchModal?: boolean;
  locationFocus?: boolean;
  onSubmit?: () => void;
  isOfferModal?: boolean;
  submitBtnText?: string;
  isLogo?: boolean;
  minLOS?: string | null;
  minLeadDays?: string | null;
}
export interface IDates {
  children: JSX.Element;
  isLogo: boolean;
  extraClass: string;
  isEditReservation?: boolean;
}

export const RATES_LABEL = `Rates`;
export const AUTO_LABEL = `AAA / Senior`;
export const GOVERNMENT_LABEL = `Government / Military`;
export const CORPORATE_LABEL = `Corporate / Promo`;
export const GROUP_LABEL = `Group`;
export const OCCUPANCY_LABEL = `Occupancy`;
export const PROMO_LABEL = `Promo`;

export const UPDATE_BUTTON_LABEL = `Update`;
export const FIND_HOTEL_BUTTON_LABEL = `Find Hotel`;
export const LRR_LABEL = `Lowest Regular Rate`;
export const PACKAGE_LABEL = `Package`;
